"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.PAYMENT_SOURCE_CREDIT = 'PAYMENT_SOURCE_CREDIT';
    Constants.CREDIT_CARD = 'PAYMENT_SOURCE_CREDIT';
    Constants.ECHECK = 'ECHECK';
    Constants.CARGOSPRINT_CREDIT = 'CARGOSPRINT_CREDIT';
    Constants.ENVIRONMENT_DEV = 'develop';
    Constants.ENVIRONMENT_STAGING = 'staging';
    Constants.ENVIRONMENT_PROD = 'production';
    return Constants;
}());
exports.Constants = Constants;
//# sourceMappingURL=constants.js.map